import { call, put, delay } from "redux-saga/effects";
import { ordersApi } from "@services/api";
import { getCartActions } from "../slices";

function* getCartWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getCartActions.pending());
    const response = yield call(ordersApi.getCart, payload);
    yield put(getCartActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getCartActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getCartWorker };
